import { defineMessages, IntlShape } from "react-intl";

export type MonthsMapOption = {
  value: number;
  label: string;
};

export const monthMessages = defineMessages({
  jan: { id: "month.jan", defaultMessage: "January" },
  feb: { id: "month.feb", defaultMessage: "February" },
  mar: { id: "month.mar", defaultMessage: "March" },
  apr: { id: "month.apr", defaultMessage: "April" },
  may: { id: "month.may", defaultMessage: "May" },
  jun: { id: "month.jun", defaultMessage: "June" },
  jul: { id: "month.jul", defaultMessage: "July" },
  aug: { id: "month.aug", defaultMessage: "August" },
  sep: { id: "month.sep", defaultMessage: "September" },
  oct: { id: "month.oct", defaultMessage: "October" },
  nov: { id: "month.nov", defaultMessage: "November" },
  dec: { id: "month.dec", defaultMessage: "December" },
});

export const getMonthsMap = (intl: IntlShape): MonthsMapOption[] => [
  { value: 1, label: intl.formatMessage(monthMessages.jan) },
  { value: 2, label: intl.formatMessage(monthMessages.feb) },
  { value: 3, label: intl.formatMessage(monthMessages.mar) },
  { value: 4, label: intl.formatMessage(monthMessages.apr) },
  { value: 5, label: intl.formatMessage(monthMessages.may) },
  { value: 6, label: intl.formatMessage(monthMessages.jun) },
  { value: 7, label: intl.formatMessage(monthMessages.jul) },
  { value: 8, label: intl.formatMessage(monthMessages.aug) },
  { value: 9, label: intl.formatMessage(monthMessages.sep) },
  { value: 10, label: intl.formatMessage(monthMessages.oct) },
  { value: 11, label: intl.formatMessage(monthMessages.nov) },
  { value: 12, label: intl.formatMessage(monthMessages.dec) },
];

const DEFAULT_YEAR = 2000; // used when year is missing; result is correct for any non-February month

export const getDaysInMonth = (month: number, year?: number) => {
  if (!month) return 31;
  const yearForCalculation = year && !Number.isNaN(year) ? year : DEFAULT_YEAR;
  return new Date(yearForCalculation, month, 0).getDate();
};

const FEBRUARY = 2;

export const isLeapYear = (year: number): boolean => {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};

export const getMaxDayForDob = (month: number, year?: number): number => {
  if (!month) return 31;

  if (month === FEBRUARY) {
    if (!year) return 29;
    return isLeapYear(year) ? 29 : 28;
  }

  return getDaysInMonth(month, year);
};
